import React, { useEffect } from 'react'
import { Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { chatListBuyer, chatUserListBuyer } from '../../../../Redux/Chats/action';
import { viewUserProfile } from '../../../../Redux/User/action';
import { IMAGE_URL } from '../../../../api';
import Header from '../../../Layout/Header';
import Footer from '../../../Layout/Footer';
import OneSignalReact from 'react-onesignal';



const ChatsUserListBuyer = () => {

    const [data, setData] = useState([]);
    const [status, setStatus] = useState(1);
    const [user, setUser] = useState({});
    const navigate = useNavigate();

    const __search = (e) => {
        chatListBuyer(e?.target?.value)((response) => {
            if (response?.status && response?.data) {
                setData(response?.data?.data[0]?.users_list)
            }
        });
    }
    const statusChat = (e) => {
        if (e.target.checked) {
            setStatus(e.target.value)
        }
    }
    useEffect(() => {

        viewUserProfile()((response) => {
            if (response && response.status) {
                setUser(response?.data?.data[0])
            }
        });
        let formData = new FormData();
        chatUserListBuyer({ formData })((response) => {
            if (response && response.status) {
                setData(response?.data)
            }
        });
    }, []);
    // window.OneSignal = window.OneSignal || [];

    useEffect(() => {
        // const OneSignal = window.OneSignal
        // OneSignal.push(function () {
        //     OneSignal.log.setLevel('trace');
        OneSignalReact.on('notificationDisplay', function (event) {
            // event.close();
            const notification_data = event.data.status
            if (notification_data === "user status") {
                chatUserListBuyer()((response) => {
                    if (response && response.status) {
                        setData(response?.data)
                    }
                });
            }
        });

        // });

    }, [])
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Chats </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Chats</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='chat-sect'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <Form>
                                {['radio'].map((type) => (
                                    <div key={`inline-${type}`} className="text-center mb-5">
                                        <Form.Check
                                            inline
                                            label="Online"
                                            name="group1"
                                            type={type}
                                            id={`inline-${type}-1`}
                                            className='online'
                                            onChange={(e) => statusChat(e)}
                                            value="1"
                                            defaultChecked
                                        />
                                        <Form.Check
                                            inline
                                            label="Offline"
                                            name="group1"
                                            type={type}
                                            id={`inline-${type}-2`}
                                            className='offline'
                                            onChange={(e) => statusChat(e)}
                                            value="2"
                                        />
                                        {/* <Form.Check
                                            inline
                                            label="Away"
                                            name="group1"
                                            type={type}
                                            id={`inline-${type}-3`}
                                            className='away'
                                            onChange={(e) => statusChat(e)}
                                            value="3"
                                        /> */}

                                    </div>
                                ))}
                            </Form>
                        </div>
                        <div className='col-lg-12'>
                            <form className="search-form d-flex align-items-center justify-content-center" >
                                <input type="text" name="query" placeholder="Search" title="Search" onChange={(e) => __search(e)} className='' />
                                <button type="submit" title="Search">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" className='search-icon searchlist-icon' fill="#fff" viewBox="0 0 16 16">
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                    </svg>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <section className="chats section-bg p-0">
                <div className="container">
                    {status == 1 ?
                        <div className="row">
                            {data?.map((task, index) =>
                                <React.Fragment>
                                    {status == task?.status[0]?.status &&

                                        <div className="col-lg-3">
                                            <div className='chats-sec' onClick={() => navigate('/chatsbuyer/' + task?.id)}>
                                                <div className="member d-flex align-items-start">
                                                    <div className="pic"><img src={IMAGE_URL + task?.image[0]?.image} className="img-fluid" alt="" /></div>
                                                    <div className="member-info">
                                                        <span style={{ color: "#1bbaed", fontWeight: "700", fontSize: "16px" }}>{task?.username}</span>
                                                        <p>Services: {task?.image[0]?.primary_service} & {task?.image[0]?.secondary_service}</p>
                                                        {task?.average_rating == "" ?
                                                            <span className="badge badge-light-warning">{"Not yet rated"} </span>
                                                            :
                                                            <span className="badge badge-light-warning">{parseFloat(task?.average_rating).toFixed(1)} <i class="bi bi-star-fill"></i> ( {task?.total_rating} ) </span>
                                                        }
                                                    </div>
                                                    <div class="online-status"></div>
                                                </div>
                                            </div>
                                        </div>

                                    }
                                </React.Fragment>
                            )}
                        </div>
                        :
                        <div className="row">
                            {data?.map((task, index) =>
                                <React.Fragment>
                                    {status == task?.status[0]?.status &&
                                        <div className="col-lg-3">
                                            <div className='chats-sec' onClick={() => navigate('/chatsbuyer/' + task?.id)}>
                                                <div className="member d-flex align-items-start">
                                                    <div className="pic"><img src={IMAGE_URL + task?.image[0]?.image} className="img-fluid" alt="" /></div>
                                                    <div className="member-info">
                                                        <span style={{ color: "#1bbaed", fontWeight: "700", fontSize: "16px" }}>{task?.username}</span>
                                                        <p>Services: {task?.image[0]?.primary_service} & {task?.image[0]?.secondary_service}</p>
                                                        {task?.average_rating == "" ?
                                                            <span className="badge badge-light-warning">{"Not yet rated"} </span>
                                                            :
                                                            <span className="badge badge-light-warning">{parseFloat(task?.average_rating).toFixed(1)} <i class="bi bi-star-fill"></i> ( {task?.total_rating} ) </span>
                                                        }
                                                    </div>
                                                    {/* <div class="offline-status"></div> */}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </React.Fragment>
                            )}
                        </div>
                    }
                </div>
            </section>

            <Footer />
        </React.Fragment>
    )
}

export default ChatsUserListBuyer;